import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const TicketSummaryByHeadChart = ({ data }) => {
  // Prepare X-axis labels
  const labels = data.map((row) => row.ticketHeadName);

  // Total Tickets dataset
  const totalTicketsDataset = {
    label: "Total Tickets",
    data: data.map((row) => row.totalTickets),
    backgroundColor: "rgba(54, 162, 235, 0.7)",
  };

  // Status keys dynamically
  const statusKeys = Array.from(
    new Set(data.flatMap((row) => Object.keys(row.statusSummary || {})))
  );

  // Status datasets for stacked chart
  const statusDatasets = statusKeys.map((key, idx) => ({
    label: key,
    data: data.map((row) => row.statusSummary?.[key] || 0),
    backgroundColor: `rgba(${50 + idx * 40}, ${100 + idx * 30}, ${200 - idx * 20}, 0.7)`,
  }));

  // Bar chart data
  const chartData = {
    labels,
    datasets: [totalTicketsDataset, ...statusDatasets],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: false,
        text: "Ticket Summary by Ticket Head",
        font: { size: 18 },
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      legend: {
        position: "bottom",
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default TicketSummaryByHeadChart;
